import { Box } from "@mui/joy";
import S3_URL from "utils/s3";

interface Applicant {
  id: string;
  name: string;
  position: string;
  videoUuid: string;
  user?: {
    fullName: string;
  };
}

const ApplicantThumbnail = ({ applicant }: { applicant: Applicant }) => {
  const videoUuid = applicant.videoUuid;
  const thumbnailUrl = `${S3_URL}processed/${videoUuid}/frames/${videoUuid}-.0000000.jpg`;

  return (
    <Box
      component="img"
      src={thumbnailUrl}
      alt={applicant.name}
      sx={{ 
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '8px'
      }}
    />
  );
};

export default ApplicantThumbnail;